<div class="app-ui-tabs" [class.app-ui-tabs--stretch]="stretch()" [class.app-ui-tabs--icon]="variant() === 'icon'">
  <div role="tablist" class="app-ui-tabs__list">
    @for (tab of tabs(); track tab.tabId()) {
      <button
        type="button"
        role="tab"
        [id]="labelId(tab)"
        [attr.aria-controls]="panelId(tab)"
        [attr.aria-selected]="isActive(tab)"
        [attr.data-state]="isActive(tab) ? 'active' : 'inactive'"
        [attr.data-testid]="'tab-' + tab.tabId()"
        [tabIndex]="isActive(tab) ? 0 : -1"
        [disabled]="tab.disabled()"
        [class]="triggerClass(tab)"
        (click)="handleActiveTabChange(tab.tabId())"
        (keydown)="onTabKeydown($event, tab)"
      >
        @if (tab.labelTemplate(); as labelTemplate) {
          <ng-container [ngTemplateOutlet]="labelTemplate" />
        } @else {
          {{ tab.label() }}
        }
      </button>
    }
  </div>

  @for (tab of tabs(); track tab.tabId()) {
    <div
      class="app-ui-tabs__panel"
      role="tabpanel"
      tabindex="0"
      [id]="panelId(tab)"
      [attr.aria-labelledby]="labelId(tab)"
      [hidden]="!isActive(tab)"
    >
      <ng-container [ngTemplateOutlet]="tab.contentTemplate()" />
    </div>
  }
</div>
